import { isBefore } from 'date-fns';
import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../reducers/rootReducer';
import { IUser, USER_FILTER } from '../../interfaces/user';

export const selectAdminDevelopers = (state: AppState) => state.adminUserReducer.developers;

export const selectAdminDevelopersDate = (state: AppState) =>
  state.adminUserReducer.developersFetched;

const sortName = (a: IUser, b: IUser) =>
  a.username.toUpperCase() > b.username.toUpperCase() ? 1 : -1;

const sortDate = (a: IUser, b: IUser) => {
  const date1 = a.dateUpdated;
  const date2 = b.dateUpdated;
  if (!date1 || !date2) return 0;
  return isBefore(new Date(date1), new Date(date2)) ? 1 : -1;
};

const filterUsers = (filter: USER_FILTER, users: IUser[]) => {
  switch (filter) {
    case USER_FILTER.NAME:
      return [...users].sort(sortName);
    case USER_FILTER.UPDATED:
      return [...users].sort(sortDate);
    default:
      return users;
  }
};

const getDisplayUsers =
  (filter: USER_FILTER, currentPage: number, rowsPerPage: number) =>
  (users: IUser[] | undefined): [IUser[], number] => {
    if (!users) return [[], 0];
    return [
      filterUsers(filter, users).slice(
        (currentPage - 1) * rowsPerPage,
        (currentPage - 1) * rowsPerPage + rowsPerPage,
      ),
      users.length,
    ];
  };

export const selectAllFilteredUsers = (
  filter: USER_FILTER,
  currentPage: number,
  rowsPerPage: number,
) => createSelector(selectAdminDevelopers, getDisplayUsers(filter, currentPage, rowsPerPage));
